<!--  Top menu -->
<nav id="mainNav" class="navbar navbar-expand-md navbar-dark fixed-top bg-primary {{router?.url == '/home' ? '' : 'bg-primary'}}">
	<div class="container">
		<a class="navbar-brand" [routerLink]="['/', 'home']" routerLinkActive="active-link">
			<img src="assets/img/e-pottery-logo-vector.png" class="img-fluid logo-img">
		</a>
		<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="true" aria-label="Toggle navigation">
			<span class="navbar-toggler-icon"></span>
		</button>
		<div class="collapse navbar-collapse" id="navbarCollapse">
			<ul menuToggleDirective id="main" class="navbar-nav ml-auto main-menu list-unstyled">
				<li menuToggleLink class="nav-item" routerLinkActive="open" *ngFor="let menuItem of menuItems.getMainMenu()">
					<a menuToggle class="nav-link" [routerLink]="['/', menuItem.state]" routerLinkActive="active-link" *ngIf="menuItem.type == 'link'" (click)="removeCollapseInClass()">
						{{ menuItem?.name }}<span *ngIf="menuItem.icon" class="ml-2"><i class="{{ menuItem?.icon }}"></i></span>
					</a>
					<a menuToggle class="nav-link" *ngIf="menuItem.type == 'command'" (click)="removeCollapseInClass();logout()">
						{{ menuItem?.name }}<span *ngIf="menuItem.icon" class="ml-2"><i class="{{ menuItem?.icon }}"></i></span>
					</a>
					<a menuToggle *ngIf="menuItem.type == 'sub'" class="nav-link" href="javascript:void(0)">{{ menuItem?.name }}&nbsp;
						<i class="{{ menuItem?.icon }}"></i>
					</a>
					<ul *ngIf="menuItem.type == 'sub' && menuItem?.children" class="sub-menu arrow-up list-unstyled" >
						<li class="nav-item" routerLinkActive="open" *ngFor="let grandchildItem of menuItem?.children">
							<a class="nav-link" [routerLink]="['/', grandchildItem.state]" routerLinkActive="active-link" *ngIf="grandchildItem.type == 'link'" (click)="removeCollapseInClass()">
								{{ grandchildItem?.name }}
							</a>
						</li>
					</ul>
				</li>
				<li>
					<div class="search-form" click-outside (clickOutside)="onClickOutside($event)">
						<span data-target="#search-style-simple" (click)="searchActiveFunction()">
							<i class="fa fa-search"></i>
						</span>
						<div class="module-container" [ngClass]="{'search-active': searchactive}" id="search-style-simple">
							<form role="search" method="get" class="search-box" action="javascript:void(0);">
								<input type="search" class="form-control" placeholder="Cerca" value="" name="" />
								<button type="submit"><i class="fa fa-search"></i></button>
							</form>
						</div><!-- /module-container -->
					</div><!-- /module -->
				</li>
				<li class="nav-item dropdown">
					<a class="nav-link dropdown-toggle notranslate" href="#" data-toggle="dropdown" aria-expanded="false">{{selectedLanguage.label}}</a>
					<div class="dropdown-menu">
					  <button type="button" class="dropdown-item notranslate" (click)="setLanguage('en','ENG')">ENG</button>
					  <button type="button" class="dropdown-item notranslate" (click)="setLanguage('fr','FRA')">FRA</button>
					  <button type="button" class="dropdown-item notranslate" (click)="setLanguage('de','DEU')">DEU</button>
					  <button type="button" class="dropdown-item notranslate" (click)="setLanguage('it','ITA')">ITA</button>
					</div>
				  </li>
			</ul>
		</div>
	</div>
</nav>